<template>
  <div class="container">
    <div class="handle-container">
      <label for="search-input">搜索：</label>
      <input type="text" v-model="searchWords" id="search-input" class="input-field" style="width: 300px;" placeholder="多个关键词用空格分隔" />
      <label for="replace-input">替换：</label>
      <input type="text" v-model="replaceWords" id="replace-input" class="input-field" style="width: 300px;" />

      <button class="search-button" @click="performSearch">预览</button>

      <button class="search-button button-red" @click="saveModify">替换并导出</button>

      <span class="highlight">替换后，录音会被清空</span>
    </div>
    <div class="table-container">
            <table class="beautified-table">
        <thead>
            <tr>
                <th>原始文本</th>
                <th>替换后的文本</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(item, index) in sortedTableData" :key="index">
                <td v-html="highlightText(item.originalText, searchKeywords)"></td>
                <td v-html="highlightText(item.replacementText, replaceKeywords)"></td>
            </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import XLSX from 'xlsx'

export default {
  components: {
  },
  data() {
    return {
        searchWords: '',
        replaceWords: '',

        tableData: [
            // { id: 1, iid : 1, originalText: '原文1', replacementText: '替换文1', sortValue: 3 },
            // { id: 1, iid : 1, originalText: '原文1', replacementText: '替换文1', sortValue: 3 },
            // { id: 2, iid : 1, originalText: '原文1', replacementText: '替换文1', sortValue: 3 },
        ],
        searchKeywords: [],
        replaceKeywords: [],
    };
  },
  computed: {
    ...mapState("scene", ["scene"]),

    sortedTableData() {
        return this.tableData.slice().sort((a, b) => {
          return (a.sortX + a.sortValue) - (b.sortX + b.sortValue);
        });
    },

    highlightText() {
        return (text, keywords) => {
            if (!keywords.length) return text;
            let regex = new RegExp(keywords.map(key => `(${escapeRegExp(key)})`).join('|'), 'gi');
            return text.replace(regex, match => `<span class="highlight">${match}</span>`);
        };
    }
  },

  watch: {
      scene: {
          handler() {
              this.initTableData();
          },
          // 深度监听，用于监听对象内部属性的变化
          deep: false,
          // 立即执行一次监听器，在组件创建时就会触发
          immediate: true
      }
  },

  created() {
      this.initTableData();
  },

  methods: {
    ...mapActions('scene', ['upgradeTexts']),

    saveModify() {
      // 弹出确认框
      if (!confirm('确定要保存数据吗？')) {
          return;
      }

      let modifiedTexts = {
        scene : [],
        knowledge : []
      };
      let modified = false;
      this.tableData.forEach(item => {
          if (item.modified) {
            modified = true;
            item.originalText = item.replacementText;
            item.replacementText = "";
            item.modified = false;
            item.sortX = 1000000;

            modifiedTexts[item.leixing].push(item);
          }
      });
      if (!modified) {
        alert('没有任何修改');
        return;
      }

      this.upgradeTexts({textS : modifiedTexts.scene, textK : modifiedTexts.knowledge});
      this.exportModify(modifiedTexts);
    },

    exportModify(modifiedTexts) {
      // 获取当前日期时间
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      const day = String(currentDate.getDate()).padStart(2, '0');
      const hours = String(currentDate.getHours()).padStart(2, '0');
      const minutes = String(currentDate.getMinutes()).padStart(2, '0');
      const seconds = String(currentDate.getSeconds()).padStart(2, '0');
      const dateTimeString = `${year}-${month}-${day}_${hours}-${minutes}-${seconds}`;

      let list = [];
      list.push(['类型', '标签', '分类', '文本']);
      for (let key in modifiedTexts) {
        modifiedTexts[key].forEach(item => {
          list.push([
            key === "scene" ? '话术' : '知识',
            item.tag,
            item.title,
            item.originalText
          ]);
        })
      }

      const worksheet = XLSX.utils.aoa_to_sheet(list);
			const newWorkbook = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(newWorkbook, worksheet, 'sheet');
			XLSX.writeFile(newWorkbook, '批量修改文本_' + dateTimeString + '.xlsx');
    },

    performSearch() {
      this.searchKeywords = this.searchWords.split(' ').filter(key => key);
      if (this.searchKeywords.length === 0) {
          alert('请输入搜索关键词');
          return;
      }

      this.replaceKeywords = this.replaceWords.split(' ').filter(key => key);
      if (this.searchKeywords.length !== this.replaceKeywords.length) {
          alert('搜索关键词和替换关键词数量必须一致');
          return;
      }
      this.tableData = this.tableData.map(item => {
          let newText = item.originalText;
          this.searchKeywords.forEach((keyword, index) => {
              const regex = new RegExp(keyword, 'gi');
              newText = newText.replace(regex, this.replaceKeywords[index]);
          });
          if (newText === item.originalText) {
              item.sortX = 1000000;
              item.modified = false;
              return item;
          }
          return {
              ...item,
              modified: true,
              sortX: 0,
              replacementText: newText
          };
      });
    },

    initTableData() {
      let sortValue = 0;
      let sceneTexts = [];
      if (this.scene.scenes) {
        this.scene.scenes.forEach((sceneItem, sceneIndex) => {
          if (!sceneItem.nodes) return;
          sceneItem.nodes.forEach((node, nodeIndex) => {
              if (!node.voices) return;
              node.voices.forEach((voice, voiceIndex) => {
                if (voice.text !== "") {
                  sortValue++;
                  sceneTexts.push({
                      leixing : 'scene',
                      id: sceneIndex,
                      iid: nodeIndex,
                      vid: voiceIndex,
                      tag: sceneItem.name,
                      title : node.name,
                      originalText: voice.text,
                      replacementText: "",
                      sortX : 1000000,
                      sortValue: sortValue,
                  });
                }
              });
          });
        });
      }

      let knowledgeTexts = [];
      if (this.scene.knowledge) {
        this.scene.knowledge.forEach((knowledgeItem, knowledgeIndex) => {
            knowledgeItem.responses.forEach((response, responseIndex) => {
              if (response.text !== "") {
                sortValue++;
                knowledgeTexts.push({
                    leixing : 'knowledge',
                    id: knowledgeIndex,
                    iid: responseIndex,
                    tag: knowledgeItem.tag,
                    title : knowledgeItem.name,
                    originalText: response.text,
                    replacementText: "",
                    sortX : 1000000,
                    sortValue: sortValue,
                });
              }
            });
        });
      }

      this.tableData = [...sceneTexts, ...knowledgeTexts];
    }
  },
};

// 转义正则表达式特殊字符
function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
</script>

<style scoped>
  .handle-container {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-top: 16px;
    margin-bottom: 16px;
    padding-left: 16px;
  }

  .input-field {
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
    outline: none;
    transition: border-color 0.3s ease;
  }

  .input-field:focus {
    border-color: #007bff;
  }

  label {
    font-size: 14px;
    font-weight: bold;
  }

  .search-button {
    padding: 8px 16px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }

  .button-red {
    background-color: #dc3545;
  }

    .beautified-table {
        width: 100%;
        border-collapse: collapse;
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
        margin-bottom: 20px;
    }

    .beautified-table th,
    .beautified-table td {
        padding: 12px 15px;
        text-align: left;
        border-bottom: 1px solid #ddd;
    }

    .beautified-table th {
        background-color: #f4f4f4;
        color: #333;
        font-weight: 600;
    }

    .beautified-table tr:hover {
        background-color: #f9f9f9;
    }

</style>
